import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { Envs } from '../envs'
import { Subscription } from '../domain/dtos/subscription'

export class GetSubscription {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(id: string): Promise<Subscription> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_WEB_URL}/payer/subscriptions/${id}`,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new Error('Erro ao buscar assinatura')
  }
}
